import { Grid, Stack } from "@mantine/core"
import { theme } from "@tfg/themes"

import { DataFetchWrapper } from "~/components/DataFetchWrapper"
import {
  HeaderControlsProvider,
  useHeaderControlsContext,
} from "~/components/contexts/useHeaderControlsContext"
import { useFindIngestions } from "~/gen/api"
import { IngestionsList } from "~/pages/Brand/DataTransfer/Import/IngestionsList"
import { BulkUpdateProductCard } from "~/pages/Brand/DataTransfer/Import/components/BulkUpdateProductCard"
import { BusinessPartnerImportCard } from "~/pages/Brand/DataTransfer/Import/components/BusinessPartnerImportCard"
import { ProductImportLegacyCard } from "~/pages/Brand/DataTransfer/Import/components/ProductImportLegacyCard"
import { config } from "~/pages/Brand/DataTransfer/config.ts"

const DataTransferImportContent = () => {
  const { sorts, setSorts, setFilters, filters } = useHeaderControlsContext()

  const ingestionListQuery = useFindIngestions(
    { sorts, filters },
    {
      query: {
        refetchInterval: 10000, // 10 seconds
      },
    }
  )

  return (
    <Stack>
      <Stack>
        <Grid>
          <Grid.Col span={theme.other.widths.grid.span}>
            <ProductImportLegacyCard
              href={config.DATA_TRANSFER_TEMPLATE}
              sorts={sorts}
              filters={filters}
            />
          </Grid.Col>
          <Grid.Col span={theme.other.widths.grid.span}>
            <BusinessPartnerImportCard sorts={sorts} filters={filters} />
          </Grid.Col>
          <Grid.Col span={theme.other.widths.grid.span}>
            <BulkUpdateProductCard />
          </Grid.Col>
        </Grid>
        <Stack>
          <DataFetchWrapper query={ingestionListQuery}>
            {({ data }) => (
              <IngestionsList
                ingestions={data.data}
                sorts={sorts}
                filters={filters}
                setSorts={setSorts}
                setFilters={setFilters}
              />
            )}
          </DataFetchWrapper>
        </Stack>
      </Stack>
    </Stack>
  )
}

export const DataTransferImport = () => {
  return (
    <HeaderControlsProvider>
      <DataTransferImportContent />
    </HeaderControlsProvider>
  )
}
